import * as React from 'react';
import { useCellSync, useCollection } from '../hooks';
import { classNames } from '@progress/kendo-react-common';
import { SchedulerViewContext } from '../context/SchedulerViewContext';
/** @hidden */
export var ITEM_SELECTION_ACTION;
(function (ITEM_SELECTION_ACTION) {
    ITEM_SELECTION_ACTION[ITEM_SELECTION_ACTION["select"] = 0] = "select";
    ITEM_SELECTION_ACTION[ITEM_SELECTION_ACTION["reset"] = 1] = "reset";
})(ITEM_SELECTION_ACTION || (ITEM_SELECTION_ACTION = {}));
/** @hidden */
export var SLOTS_SELECTION_ACTION;
(function (SLOTS_SELECTION_ACTION) {
    SLOTS_SELECTION_ACTION[SLOTS_SELECTION_ACTION["select"] = 0] = "select";
    SLOTS_SELECTION_ACTION[SLOTS_SELECTION_ACTION["reset"] = 1] = "reset";
})(SLOTS_SELECTION_ACTION || (SLOTS_SELECTION_ACTION = {}));
/**
 * @hidden
 */
export var BaseView = React.forwardRef(function (props, ref) {
    var element = React.useRef(null);
    React.useImperativeHandle(ref, function () { return element.current; });
    var _a = useCollection([]), items = _a[0], dispatchItems = _a[1];
    var _b = useCollection([]), slots = _b[0], dispatchSlots = _b[1];
    var _c = React.useState([]), selectedSlots = _c[0], setSelectedSlots = _c[1];
    var _d = React.useState(null), selectedItem = _d[0], setSelectedItem = _d[1];
    var handleItemSelectionAction = React.useCallback(function (action) {
        switch (action.type) {
            case ITEM_SELECTION_ACTION.select:
                setSelectedSlots([]);
                setSelectedItem(action.item);
                break;
            case ITEM_SELECTION_ACTION.reset:
                setSelectedSlots([]);
                setSelectedItem(null);
                break;
            default:
                break;
        }
    }, [setSelectedSlots, setSelectedItem]);
    var handleSlotsSelectionAction = React.useCallback(function (action) {
        switch (action.type) {
            case SLOTS_SELECTION_ACTION.select:
                setSelectedItem(null);
                setSelectedSlots(action.slots);
                break;
            case SLOTS_SELECTION_ACTION.select:
                setSelectedItem(null);
                setSelectedSlots([]);
                break;
            default:
                break;
        }
    }, [setSelectedSlots, setSelectedItem]);
    var className = React.useMemo(function () { return classNames('k-scheduler-layout k-scheduler-layout-flex', props.className); }, [props.className]);
    useCellSync({ element: element, selector: '.k-group-cell', attribute: 'data-depth-index', explicitDepth: true });
    useCellSync({ element: element, selector: '.k-side-cell', attribute: 'data-depth-index', explicitDepth: false });
    return (React.createElement(SchedulerViewContext, { props: props.props, ranges: props.ranges, items: [items, dispatchItems], slots: [slots, dispatchSlots], selectedItem: [selectedItem, handleItemSelectionAction], selectedSlots: [selectedSlots, handleSlotsSelectionAction] },
        React.createElement("div", { ref: element, style: props.style, className: className, role: "presentation" }, props.children)));
});
BaseView.displayName = 'KendoReactSchedulerBaseView';
//# sourceMappingURL=BaseView.js.map